import { PostOutlineIcon } from './PostOutlineIcon';

/**
 * author: Michael Irigoyen
 * id A7CB61B3-B3C5-4EEE-AC94-D0B2347FFA1B
 * name post-outline
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/post-outline.svg
 * tags
 */
export const BlogOutlineIcon = PostOutlineIcon;
export default BlogOutlineIcon